module.exports = __webpack_public_path__ + "static/img/MBTI-picture2.7058db03.jpg";